import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../lib/auth";
import { Loader2, ArrowRight } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from || "/account";
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate(redirectTo);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-16">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">Join Welljio</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mb-8">Create your account.</h1>
      <form onSubmit={submit} className="bg-white border border-slate-100 rounded-3xl p-8 space-y-4" data-testid="register-form">
        <input data-testid="register-name" required placeholder="Full name" value={form.name} onChange={change("name")} className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm" />
        <input data-testid="register-email" required type="email" placeholder="Email" value={form.email} onChange={change("email")} className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm" />
        <input data-testid="register-password" required type="password" minLength={6} placeholder="Password (min 6 characters)" value={form.password} onChange={change("password")} className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm" />
        {error && <p data-testid="register-error" className="text-sm text-red-600">{error}</p>}
        <button data-testid="register-submit" disabled={loading} type="submit" className="w-full bg-welljio-ink text-white rounded-full py-4 font-medium hover:bg-slate-800 transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin"/> Creating...</> : <>Create account <ArrowRight className="w-4 h-4" strokeWidth={1.5}/></>}
        </button>
      </form>
      <p className="text-sm text-welljio-muted mt-6 text-center">
        Already have an account? <Link to="/login" state={location.state} className="text-welljio-accent hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
